import { render, staticRenderFns } from "./detailsReceiptRecord.vue?vue&type=template&id=ef5130c4&scoped=true"
import script from "./detailsReceiptRecord.vue?vue&type=script&lang=js"
export * from "./detailsReceiptRecord.vue?vue&type=script&lang=js"
import style0 from "./detailsReceiptRecord.vue?vue&type=style&index=0&id=ef5130c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5130c4",
  null
  
)

export default component.exports